import React, { useRef } from 'react';

import Messages from '../../../hooks/Messages';
import Relations from '../../../hooks/Relations';
import { useSessionId } from '../../../hooks/SessionId';
import { useConfiguration } from '../../../hooks/Configuration';
import Communication from './Communication';
import FaqList from './FaqList';
import Footer from './Footer';
import WS from '../WS';

function Chat() {
    const chatEndRef = useRef<HTMLDivElement>(null);
    const configuration = useConfiguration();

    const scrollToBottom = (delay = 0) => {
        setTimeout(
            () => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }),
            delay
        );
    }

    return (
        <>
            <div
                id='stx-chat-faq-wrapper'
                style={{
                    backgroundColor: configuration?.styles.windowBgColor
                }}>
                <Communication scrollToBottom={scrollToBottom} />
                <FaqList scrollToBottom={scrollToBottom} />
                <div ref={chatEndRef} />
            </div >
            <Footer />
        </>
    );
}

function ChatWrapperMessagess() {
    const sessionId = useSessionId();

    return (
        <Relations key={sessionId?.sessionId}>
            <Messages>
                <WS />
                <Chat />
            </Messages>
        </Relations>
    )
}

export default ChatWrapperMessagess;
